import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
const History = () => {
  useEffect(() => {
    document.title = "History -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> About Us</li>
          <li>History</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> History </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="clearfix">
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/history.jpg"
                    alt="TAFS"
                    className="col-lg-3 col-md-4 float-md-end  left-img img-fluid"
                  />{" "}
                </LazyLoad>
                <p>
                  <b>The Air Force School (TAFS)</b> was established in
                  temporary wartime hutments at Wellington Camp, Club Road, New
                  Delhi on <b>18 July 1955</b> with the aim of providing
                  comprehensive modern education to children of personnel of the
                  Indian Air Force. <b>In May 1967,</b> the school shifted to
                  its present Aravali Campus at Subroto Park, Delhi Cantt. The
                  school celebrated its Silver Jubilee in 1980. The School is
                  situated on the Aravali ridge - amidst picturesque
                  surroundings - lined by rows of majestic Eucalyptus and Ashoka
                  trees. In the 15 acre area of the school, there are numerous
                  varieties of Bougainvillea, ranging from the common Pink to
                  the rare lovely Mary Palmer which blossom throughout the year.
                  Although the school was established primarily for the benefit
                  of children belonging to the IAF personnel, it has always been
                  open towards Army and Navy personnel as well as to Civilians.
                </p>
                <p>
                  Thereby it satisfies a long-felt need of the Air Force
                  personnel and simultaneously provides quality education to a
                  much wider spectrum of children, from all over the country.
                </p>
                <p>
                  The Air Force School is a co-educational public school with
                  boarding facilities for boys of classes VI to XII. The school
                  is affiliated with the Central Board of Secondary Education
                  and is a member of the National Progressive Schools Conference
                  (NPSC). The school has been declared ISO certified in the year{" "}
                  <b>2007</b>.
                </p>
                <p>
                  In recognition of its excellence in education The Air Force
                  School (TAFS) was ranked number 1 in South West Delhi by the
                  Times School Survey (published in Times of India) for two
                  consecutive years <b>2023 and 2024</b>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default History;
